var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_475_566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9.03471C13.8352 9.03471 13.5 9.37076 13.5 9.78467V15.7847C13.5 16.1979 13.164 16.5347 12.75 16.5347H2.25C1.83595 16.5347 1.50005 16.1979 1.50005 15.7847V5.28467C1.50005 4.87144 1.83595 4.53471 2.25 4.53471H8.25004C8.66478 4.53471 9 4.19867 9 3.78476C9 3.37071 8.66478 3.03467 8.25004 3.03467H2.25C1.00951 3.03467 0 4.04417 0 5.28467V15.7847C0 17.0252 1.00951 18.0347 2.25 18.0347H12.75C13.9905 18.0347 15 17.0252 15 15.7847V9.78467C15 9.36993 14.6647 9.03471 14.25 9.03471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03283 8.35147C6.98037 8.40393 6.94507 8.47067 6.93011 8.54263L6.39988 11.1947C6.37516 11.3176 6.41416 11.4444 6.5026 11.5337C6.57387 11.6049 6.66987 11.6431 6.76819 11.6431C6.79209 11.6431 6.81695 11.6409 6.84167 11.6357L9.49294 11.1055C9.56641 11.0904 9.63315 11.0552 9.68493 11.0026L15.6189 5.06862L12.9676 2.41748L7.03283 8.35147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4509 0.583614C16.7198 -0.147663 15.5302 -0.147663 14.7997 0.583614L13.7617 1.62155L16.413 4.27282L17.4509 3.23475C17.805 2.88154 18 2.4105 18 1.90953C18 1.40855 17.805 0.937512 17.4509 0.583614Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_475_566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b28f7aba1e0ffff13b491a91775ab4c9.svg";
export { ForwardRef as ReactComponent };